<template>
  <div>
    <v-card
      class="mx-auto"
      color="transparent"
      elevation="0"
    >
      <div ref="scrollTarget"></div>

      <v-card
        :style="`z-index: 10; position: sticky; top: ${focusModeToolbarTop()};`"
        color="rgba(255, 255, 255, 0.8)"
      >
        <v-toolbar
          flat
          color="transparent"
        >
          <section
            class="container d-flex align-center col-12 px-0"
            style="height: 100%; gap: 16px;"
          >
            <v-btn small icon fab class="px-0" text :to="getBackRoute()">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>

            <v-skeleton-loader
              :loading="!application.hasOwnProperty('uuid')"
              type="text"
              class="text-truncate"
              min-width="200px"
            >
              <v-toolbar-title>Candidature de <strong v-if="application.collaborator">{{ collaboratorName(application.collaborator) }}</strong></v-toolbar-title>
            </v-skeleton-loader>
            <v-spacer />
            <section
              class="d-flex align-center"
              style="gap: 32px;"
            >
              <div
                class="d-none d-md-flex align-center"
                style="gap: 32px;"
              >
                <v-skeleton-loader
                  :loading="!application.hasOwnProperty('uuid')"
                  type="list-item"
                  min-width="200px"
                >
                  <h4
                    class="d-flex align-center"
                    style="gap: 16px;"
                  >
                    <span>Source: </span>
                    <span
                      class="
                        py-1 px-4
                        primary white--text
                      "
                      style="border-radius: 10px;"
                    >
                      {{ application.source || 'N\A' }}
                    </span>
                  </h4>
                </v-skeleton-loader>

                <v-skeleton-loader
                  :loading="!application.hasOwnProperty('uuid')"
                  type="list-item"
                  min-width="200px"
                >
                  <RecruiterStatus
                    :item="application"
                    @handle-loading="(value) => handleLoading(value)"
                  />
                </v-skeleton-loader>
              </div>

              <v-tooltip
                :disabled="!application.recruiter"
                bottom
              >
                <template #activator="{ on }">
                  <v-btn
                    :color="application.recruiter ? 'light-blue' : 'primary'"
                    icon
                    small
                    :loading="!application.uuid"
                    v-on="on"
                    @click="updateApplication(application, 'stared')"
                  >
                    <v-icon>
                      {{ application.stared ? 'mdi-star': 'mdi-star-outline' }}
                    </v-icon>
                  </v-btn>
                </template>
                <div
                  v-if="application.recruiter"
                >
                  <p
                    class="
                      mb-0
                      caption font-weight-bold
                    "
                  >
                    {{ collaboratorName(application.recruiter) }} -
                    <span class="font-weight-medium">{{ application.recruiter.email }}</span>
                  </p>
                </div>
              </v-tooltip>
            </section>
          </section>
        </v-toolbar>

        <v-toolbar
          flat
          elevation="0"
          class="d-block d-md-none"
        >
          <section
            class="container d-flex align-center col-12 px-0"
            style="height: 100%; gap: 16px;"
          >
            <section
              class="
                d-flex justify-space-between align-center
                col-12
              "
              style="gap: 32px;"
            >
              <v-skeleton-loader
                :loading="!application.hasOwnProperty('uuid')"
                type="list-item"
                width="50%"
              >
                <h4
                  class="d-flex align-center"
                  style="gap: 16px;"
                >
                  <span>Source: </span>
                  <span
                    class="
                      py-1 px-4
                      primary white--text
                    "
                    style="border-radius: 10px;"
                  >
                    {{ application.source || 'N\A' }}
                  </span>
                </h4>
              </v-skeleton-loader>

              <v-skeleton-loader
                :loading="!application.hasOwnProperty('uuid')"
                type="list-item"
                width="50%"
              >
                <RecruiterStatus
                  :item="application"
                  @handle-loading="(value) => handleLoading(value)"
                />
              </v-skeleton-loader>
            </section>
          </section>
        </v-toolbar>
        <v-progress-linear
          v-if="isLoading"
          indeterminate
          color="primary"
        />
      </v-card>

      <section
        class="
          md-and-up-sticky
          d-flex flex-column flex-md-row
          px-4 py-1 py-md-0
        "
        :class="{ 'mt-6 mt-md-0' : focusMode }"
        :style="`background-color: rgba(255, 255, 255, 0.8); gap: 16px; top: ${focusModeToolbarTop('tabs')}; z-index: 2;`"
      >
        <v-tabs
          v-show="!isChatFullscreen"
          v-model="tabs.activeTab"
          centered
          background-color="transparent"
          show-arrows
          @change="changedTab"
        >
          <v-tab
            href="#candidate"
            :disabled="!canPerformAction('VIEW_PROSPECT') || !application?.uuid"
          >
            CANDIDAT
          </v-tab>
          <v-tab
            href="#application"
            :disabled="!canPerformAction('VIEW_APPLICATION') || !application?.uuid"
          >
            CANDIDATURE
          </v-tab>
          <v-tab
            href="#center-applications"
            :disabled="!canPerformAction('VIEW_APPLICATION') || !application?.uuid"
          >
            CANDIDATURES DU CENTRE
          </v-tab>
          <v-tab
            href="#other-applications"
            :disabled="!canPerformAction('VIEW_APPLICATION') || !application?.uuid"
          >
            AUTRES CANDIDATURES
          </v-tab>
        </v-tabs>
        <v-skeleton-loader
          :loading="!application.hasOwnProperty('uuid')"
          type="button, text, button"
          class="d-flex justify-end align-center mx-auto"
          style="gap: 6px;"
        >
          <section
            class="d-flex justify-end align-center mx-auto"
          >
            <v-btn
              icon
              :disabled="!canPerformAction('VIEW_APPLICATION') || !application?.uuid || canViewPreviewsCandidature"
              @click="viewPreviewsCandidature"
            >
              <v-icon>
                mdi-chevron-left
              </v-icon>
            </v-btn>

            <span class="px-2 text-no-wrap">
              {{ actualCandidatureIndex > -1 ? actualCandidatureIndex + 1 : 0 }} sur {{ candidatures.length }}
            </span>

            <v-btn
              icon
              :disabled="!canPerformAction('VIEW_APPLICATION') || !application?.uuid || canViewNextCandidature"
              @click="viewNextCandidature"
            >
              <v-icon>
                mdi-chevron-right
              </v-icon>
            </v-btn>
          </section>
        </v-skeleton-loader>
      </section>

      <section
        class="
          d-md-flex justify-space-between
          my-8 px-4 px-md-8
        "
        :class="{ 'mt-12' : focusMode }"
      >
        <div
          v-show="!isChatFullscreen"
          :class="[
            { 'md-col-8' : !['other-applications', 'center-applications'].includes(tabs.activeTab) && !hideSidebar },
            ( ['other-applications', 'center-applications'].includes(tabs.activeTab) ? 'col-12 pa-0' : 'mr-md-6 pa-0' ),
          ]"
        >
          <v-card-text
            class="
              d-flex flex-column
              pa-0
            "
            style="gap: 26px;"
          >
            <v-expansion-panels
              v-show="tabs.activeTab === 'candidate'"
              v-model="tabs.panels.candidate"
              multiple
              flat
            >
              <Application
                :fields="forms.personalInformation.fields"
                title="Coordonnées"
                :application="application"
                :is-loading="isLoading"
                permission="PROSPECT"
                @is-edit-mode="(value) => changeOpenPanels('candidate', value, 0)"
                @save-changes="(data) => updateProspect({ uuid: application.collaborator.uuid, ...data, ...input })"
              />

              <Document
                title="Tous les documents"
                :collaborator-uuid="application.collaborator?.uuid"
                :items="application.attachments"
                :is-loading="isLoading"
                permission="APPLICATION"
                @is-edit-mode="(value) => changeOpenPanels('application', value, 2)"
                @attachment-uploaded="(attachments) => setAplicationAttachments(attachments)"
                @attachment-delete="(attachmentIndex) => deleteAplicationAttachment(attachmentIndex)"
                @attachment-edit="(attachments) => editAplicationAttachments(attachments)"
              />

              <Competence
                :fields="forms.experiences.fields"
                title="Expériences professionelles"
                :items="application.experiences"
                permission="APPLICATION"
                @is-edit-mode="(value) => changeOpenPanels('application', value, 0)"
                @save-changes="(competenceIndex, data, isDelete) => competencePopup('experiences', competenceIndex, data, isDelete)"
              />

              <Competence
                :fields="forms.formations.fields"
                title="Formations"
                permission="APPLICATION"
                :items="application.formations"
                @is-edit-mode="(value) => changeOpenPanels('application', value, 1)"
                @save-changes="(competenceIndex, data, isDelete) => competencePopup('formations', competenceIndex, data, isDelete)"
              />

              <Competence
                title="Langues"
                :fields="forms.languages.fields"
                :items="application.languages"
                permission="APPLICATION"
                @is-edit-mode="(value) => changeOpenPanels('candidate', value, 2)"
                @save-changes="(competenceIndex, data, isDelete) => competencePopup('languages', competenceIndex, data, isDelete)"
              />

              <Application
                :fields="forms.consentToShareProfile.fields"
                title="Préférences de contact"
                permission="APPLICATION"
                :application="application"
                :is-loading="isLoading"
                @is-edit-mode="(value) => changeOpenPanels('candidate', value, 1)"
                @save-changes="(data) => updateApplication({ uuid: application.uuid, ...data, ...input })"
              />
            </v-expansion-panels>
            <v-expansion-panels
              v-show="tabs.activeTab === 'application'"
              v-model="tabs.panels.application"
              multiple
              flat
            >
              <Application
                title="Candidature"
                :fields="forms.application.fields"
                :application="application"
                :is-loading="isLoading"
                permission="APPLICATION"
                @is-edit-mode="(value) => changeOpenPanels('application', value, 3)"
                @save-changes="(data) => updateApplication({ uuid: application.uuid, ...data, ...input })"
              />
            </v-expansion-panels>

            <v-container
              v-if="tabs.activeTab === 'center-applications'"
              class="col-12 pa-0"
            >
              <v-skeleton-loader
                :loading="isLoading"
                :type="`list-item@10`"
              >
                <ListApplications
                  variant="center"
                  :applications="applications.center"
                />
              </v-skeleton-loader>
            </v-container>

            <v-container
              v-if="tabs.activeTab === 'other-applications'"
              class="col-12 pa-0"
            >
              <v-skeleton-loader
                :loading="isLoading"
                :type="`list-item@10`"
              >
                <ListApplications
                  variant="other"
                  :applications="applications.other"
                />
              </v-skeleton-loader>
            </v-container>
          </v-card-text>
        </div>

        <section
          v-if="!['other-applications', 'center-applications'].includes(tabs.activeTab)"
          v-show="!isChatFullscreen"
          class="
            relative justify-center
            px-0
          "
          :class="{ 'd-none d-md-flex' : !isChatFullscreen }"
        >
          <v-btn
            absolute
            fab
            top
            dark
            x-small
            color="primary"
            style="z-index: 1;"
            @click="changeSideBar()"
          >
            <v-icon dark>
              {{ hideSidebar ? "mdi-backburger" : "mdi-forwardburger" }}
            </v-icon>
          </v-btn>
          <v-divider
            class="fill-height"
            inset
            vertical
          />
        </section>

        <section
          v-show="!['other-applications', 'center-applications'].includes(tabs.activeTab)"
          :class="[
            isChatFullscreen ? 'col-12 px-0 d-block' : 'col-3 pl-6 pa-0 d-none',
            hideSidebar ? 'd-md-none' : 'd-md-block'
          ]"
        >
          <Chat
            :messages="application.notes"
            class="flex-grow-1"
            :collaborator-uuid="user?.uuid"
            :is-fullscreen="isChatFullscreen"
            permission="APPLICATION"
            style="z-index: 1; position: sticky;"
            :style="`top: ${$store.state.focusMode ? '162px': '232px'};`"
            @toggle-fullscreen="toggleChatFullScreen"
            @add-message="(message) => addNotes(message)"
          />
        </section>
      </section>
    </v-card>

    <v-btn
      v-if="!['other-applications', 'center-applications'].includes(tabs.activeTab)"
      color="info"
      fixed
      right
      fab
      class="d-block d-md-none"
      style="bottom: 80px; z-index: 1000;"
      @click="drawer = true"
    >
      <v-icon>mdi-chat-outline</v-icon>
    </v-btn>

    <!-- Mobile: Drawer -->
    <v-navigation-drawer
      v-model="drawer"
      app
      temporary
      right
      style="z-index: 1000;"
      width="100%"
    >
      <Chat
        v-show="!['other-applications', 'center-applications'].includes(tabs.activeTab)"
        :messages="application.notes"
        class="flex-grow-1"
        :collaborator-uuid="user?.uuid"
        is-fullscreen
        permission="APPLICATION"
        @toggle-fullscreen="drawer = false"
        @add-message="(message) => addNotes(message)"
      />
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import moment from 'moment';

import { requests } from '@/mixins/index';

import Competence from '@/components/application/Competence.vue';
import Application from '@/components/application/Application.vue';
import Document from '@/components/dynamic/form/components/Document.vue';
import Chat from '@/components/layouts/Chat.vue';
import RecruiterStatus from '@/components/application/components/RecruiterStatus.vue';
import ListApplications from '@/components/application/components/ListApplications.vue';

export default {
  name: 'Candidature',
  components: {
    Application,
    Competence,
    Document,
    Chat,
    RecruiterStatus,
    ListApplications
  },
  data () {
    return {
      drawer: false,
      candidatureUuid: this.$route.params.candidatureUuid,
      application: {},
      isLoading: false,
      editList: [],
      forms: {
        personalInformation: {
          fields: [
            {
              name: 'firstname',
              label: 'Prénom',
              computed: 'collaborator.firstname',
              viewType: 'Text',
              icon: 'account',
              type: 'text',
              required: true,
              mandatory: true
            },
            {
              name: 'lastname',
              label: 'Nom',
              computed: 'collaborator.lastname',
              viewType: 'Text',
              icon: 'account',
              type: 'text',
              required: true,
              mandatory: true
            },
            {
              name: 'birth_date',
              label: 'Date de naissance',
              computed: 'collaborator.birth_date',
              component: 'DatePicker',
              icon: 'calendar',
              type: 'date',
              min: '1920-01-01',
              required: true,
              mandatory: true
            },
            {
              name: 'mobilephone',
              label: 'Mobile',
              computed: 'collaborator.mobilephone',
              component: 'MobilePhoneInput',
              icon: 'phone',
              type: 'phone',
              required: true,
              mandatory: true
            },
            {
              name: 'email',
              label: 'E-mail',
              computed: 'collaborator.email',
              viewType: 'Text',
              icon: 'email',
              type: 'text',
              required: true,
              mandatory: true,
              rules: [
                value => {
                  const emailRegex = /^(?=[^\s@]{0,64}@)[^\s@]+@[^\s@]+\.[^\s@.]+$/;
                  return emailRegex.test(value) || 'Format d\'email invalide';
                }
              ]
            },
            {
              name: 'employeeNumber',
              label: 'Matricule',
              computed: 'collaborator.employeeNumber',
              viewType: 'Text',
              icon: 'card-account-details',
              type: 'text',
              disabled: true,
              readonly: true
            }
          ]
        },
        consentToShareProfile: {
          fields: [
            {
              name: 'optin',
              label: 'J\'accepte que mon profil soit partagé au niveau de toutes les entités du groupe UCPA',
              viewType: 'Switch',
              icon: 'signature',
              type: 'text',
              fullWidth: true
            }
          ]
        },
        experiences: {
          popup: {
            add: {
              title: 'Sauvegarder - Expérience professionnelle',
              text: 'Souhaitez-vous confirmer l’enregistrement ?',
              checkbox: {
                show: true,
                checked: false,
                label: 'Sauvegarder également dans l’espace du candidat'
              }
            },
            edit: {
              title: 'Mise à jour - Expérience professionnelle',
              text: 'Souhaitez-vous confirmer la mise à jour de l\'enregistrement ?',
              checkbox: {
                show: true,
                checked: false,
                label: 'Mettre à jour également dans l’espace du candidat'
              }
            },
            delete: {
              title: 'Suppression - Expérience professionnelle',
              text: 'Souhaitez-vous confirmer la suppression de l’enregistrement ?',
              checkbox: {
                show: true,
                checked: false,
                label: 'Supprimer également dans l’espace du candidat'
              }
            }
          },
          fields: [
            {
              name: 'title',
              label: 'Intitulé de poste',
              viewType: 'Text',
              icon: 'format-title',
              type: 'text',
              required: true,
              mandatory: true
            },
            {
              name: 'location',
              label: 'Lieu',
              viewType: 'Text',
              icon: 'map-marker',
              type: 'text'
            },
            {
              name: 'contractType',
              label: 'Type de contrat',
              viewType: 'Select',
              icon: 'file-sign',
              clearable: true,
              optionsByReference: 'contract_type'
            },
            {
              name: 'startDate',
              label: 'Date de début',
              component: 'DatePicker',
              icon: 'calendar',
              type: 'date',
              max: 'endDate'
            },
            {
              name: 'endDate',
              label: 'Date de fin',
              component: 'DatePicker',
              icon: 'calendar',
              type: 'date',
              min: 'startDate'
            },
            {
              name: 'description',
              label: 'Description',
              viewType: 'Textarea',
              icon: 'text-long',
              type: 'text',
              fullWidth: true
            }
          ]
        },
        formations: {
          popup: {
            add: {
              title: 'Sauvegarder - Formation',
              text: 'Souhaitez-vous confirmer l’enregistrement ?',
              checkbox: {
                show: true,
                checked: false,
                label: 'Sauvegarder également dans l’espace du candidat'
              }
            },
            edit: {
              title: 'Mise à jour - Formation',
              text: 'Souhaitez-vous confirmer la mise à jour de l\'enregistrement ?',
              checkbox: {
                show: true,
                checked: false,
                label: 'Mettre à jour également dans l’espace du candidat'
              }
            },
            delete: {
              title: 'Suppression - Formation',
              text: 'Souhaitez-vous confirmer la suppression de l’enregistrement ?',
              checkbox: {
                show: true,
                checked: false,
                label: 'Supprimer également dans l’espace du candidat'
              }
            }
          },
          fields: [
            {
              name: 'qualificationUuid',
              label: 'Diplômes et qualifications',
              viewType: 'Select',
              icon: 'certificate',
              component: 'PositionInput',
              required: true,
              mandatory: true,
              contentWtype: 'qualification',
              computedLabel: 'qualification.name'
            },
            {
              name: 'title',
              label: 'Domaine d\'études',
              viewType: 'Text',
              icon: 'briefcase-outline',
              type: 'text',
              required: true,
              mandatory: true
            },
            {
              name: 'institution',
              label: 'École',
              viewType: 'Text',
              icon: 'school-outline',
              type: 'text',
              required: true,
              mandatory: true
            },
            {
              name: 'startDate',
              label: 'Date de début',
              component: 'DatePicker',
              icon: 'calendar',
              type: 'date',
              max: 'endDate'
            },
            {
              name: 'endDate',
              label: 'Date de fin',
              component: 'DatePicker',
              icon: 'calendar',
              type: 'date',
              min: 'startDate'
            }
          ]
        },
        languages: {
          popup: {
            add: {
              title: 'Sauvegarder - Langue',
              text: 'Souhaitez-vous confirmer l’enregistrement ?',
              checkbox: {
                show: true,
                checked: false,
                label: 'Sauvegarder également dans l’espace du candidat'
              }
            },
            edit: {
              title: 'Mise à jour - Langue',
              text: 'Souhaitez-vous confirmer la mise à jour de l\'enregistrement ?',
              checkbox: {
                show: true,
                checked: false,
                label: 'Mettre à jour également dans l’espace du candidat'
              }
            },
            delete: {
              title: 'Suppression - Langue',
              text: 'Souhaitez-vous confirmer la suppression de l’enregistrement ?',
              checkbox: {
                show: true,
                checked: false,
                label: 'Supprimer également dans l’espace du candidat'
              }
            }
          },
          fields: [
            {
              name: 'language',
              label: 'Sélectionner',
              viewType: 'Select',
              icon: 'translate',
              type: 'text',
              required: true,
              mandatory: true,
              clearable: true,
              optionsByReference: 'languages'
            },
            {
              name: 'level',
              label: 'Niveau',
              viewType: 'Select',
              icon: 'ab-testing',
              type: 'text',
              required: true,
              mandatory: true,
              clearable: true,
              optionsByReference: 'levels'
            }
          ]
        },
        application: {
          fields: [
            {
              name: 'ucpaExperience',
              label: "J'ai déjà travaillé dans le groupe associati UCPA",
              viewType: 'Switch',
              icon: 'account-hard-hat',
              required: true,
              mandatory: true
            },
            {
              name: 'disabilityStatus',
              label: 'As-tu une reconnaissance de la qualité de travailleur handicapé (RQTH)',
              viewType: 'Switch',
              icon: 'account-injury',
              fullWidth: true,
              required: true,
              mandatory: true
            },
            {
              name: 'disability',
              label: 'Avez-vous un statut de travailleur handicapé que vous souhaitez nous communiquer ?',
              viewType: 'Select',
              icon: 'account-injury',
              optionsByReference: 'disability',
              clearable: true,
              required: true,
              fullWidth: true,
              hidden: true,
              mandatory: true
            },
            {
              name: 'availabilityDate',
              label: 'Peux-tu nous indiquer ta date de disponibilité ?',
              viewType: 'Text',
              placeholder: this.getDefaultAvailabilityDate(),
              icon: 'calendar',
              type: 'text'
            },
            {
              name: 'salaryExpectation',
              label: 'Peux-tu nous indiquer ta prétention salariale ?',
              viewType: 'Text',
              icon: 'cash',
              type: 'text'
            },
            {
              name: 'positionUuid',
              label: 'Poste',
              component: 'PositionInput',
              contentWtype: 'position',
              computed: 'position.uuid',
              computedLabel: 'position.name',
              viewType: 'Select',
              icon: 'post-outline'
            },
            {
              name: 'tradeUuid',
              label: 'Métier',
              component: 'PositionInput',
              contentWtype: 'trade',
              computed: 'trade.uuid',
              computedLabel: 'trade.name',
              viewType: 'Select',
              required: true,
              mandatory: true,
              icon: 'briefcase'
            },
            {
              name: 'entityUuid',
              label: 'Centre',
              component: 'PositionInput',
              contentWtype: 'entity',
              computed: 'entity.uuid',
              computedLabel: 'entity.name',
              viewType: 'Select',
              icon: 'domain'
            },
            {
              name: 'motivation',
              label: "Quelle est ta motivation à rejoindre l'aventure UCPA ?",
              viewType: 'Textarea',
              icon: 'text-long',
              type: 'text'
            }
          ]
        }
      },
      input: {},
      mobilePhoneIsValid: true,
      hideSidebar: false,
      isChatFullscreen: false,
      tabs: {
        activeTab: 'candidate',
        panels: {
          candidate: [0, 1, 2, 3, 4, 5],
          application: [0]
        }
      },
      applications: {
        offer: [],
        center: [],
        other: []
      },
      candidatures: []
    };
  },
  computed: {
    ...mapState(['references', 'user', 'activeWorkspace', 'focusMode', 'appliedFilters', 'query', 'sort', 'activeBoardConfiguration', 'offersUuidFilter']),
    ...mapGetters(['getActiveWorkspaceUuid', 'canPerformAction', 'hasWorkspaceAccess']),
    collaboratorName () {
      return collaborator => `${collaborator.firstname} ${collaborator.lastname}`;
    },
    formatedDate () {
      return date => {
        if (!date) return '';

        return moment(date).format('DD-MM-YYYY');
      };
    },
    actualCandidatureIndex () {
      if (!this.application?.uuid || !this.candidatures?.length) return 0;

      // Create a reversed copy of the array and find the index
      const reversedOffers = [...this.candidatures].reverse();
      return reversedOffers.findIndex(app => app.uuid === this.application.uuid);
    },
    canViewPreviewsCandidature () {
      // Disable previous button if we're at the first item or index not found
      return this.actualCandidatureIndex <= 0;
    },
    canViewNextCandidature () {
      // Disable next button if we're at the last item or index not found
      return this.actualCandidatureIndex === -1 || this.actualCandidatureIndex >= this.candidatures.length - 1;
    },
    focusModeToolbarTop () {
      return (section = null) => {
        if (this.$vuetify.breakpoint.xsOnly) {
          return '64px';
        }

        if (section === 'tabs') {
          return this.focusMode ? '88px' : '150px';
        }

        return this.focusMode ? '24px' : '88px';
      };
    }
  },
  watch: {
    async '$route.params.candidatureUuid' (newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.candidatureUuid = newVal;
        this.application = {};
        this.applications.center = [];
        this.applications.other = [];
        await this.fetchApplication();
        this.changedTab(this.tabs.activeTab);
      }
    }
  },
  mounted () {
    this.scrollTo('scrollTarget');

    this.fetchApplication();
    this.getApplications();
  },
  methods: {
    scrollTo (field) {
      this.$vuetify.goTo(this.$refs[field], {
        duration: 500,
        offset: 64 + 16,
        easing: 'easeInOutCubic'
      });
    },
    getBackRoute () {
      if (this.activeWorkspace === 'spontaneous') {
        return { name: 'candidature-spontanee-list' };
      }

      // Handle navigation back to correct list based on application type
      if (!this.application.offer) return null;

      // Check current route to determine the correct parent
      const currentRouteName = this.$router.currentRoute.name;

      if (currentRouteName === 'candidature') {
        return { name: 'candidatures' };
      }

      if (currentRouteName === 'offer-candidature') {
        return {
          name: 'offer-candidatures',
          params: { offerUuid: this.application.offer.uuid }
        };
      }

      return {
        name: 'offer-candidatures',
        params: { offerUuid: this.application.offer.uuid }
      };
    },
    async getApplications () {
      this.loading = true;

      const variables = {
        wtype: 'application',
        indice: 'ES_COLLABORATOR_INDICE',
        online: true,
        persistedFilters: [{ exists: { field: 'collaborator.uuid' } }],
        // Reuse the facets, search query and sort applied in the list so the
        // prev/next navigation only walks the currently filtered results.
        filtersConfiguration: this.activeBoardConfiguration?.filters || [],
        activeFilters: this.appliedFilters.filter(f => !['showOffers'].includes(f.attribute)),
        query: this.query,
        sort: this.sort,
        offersUuidFilter: this.offersUuidFilter,
        size: 1000
      };

      if (this.activeWorkspace === 'spontaneous') {
        variables.persistedFilters.push({ match: { isSpontaneousApplication: true } });
      } else {
        variables.persistedFilters.push({ match: { 'entity.uuid': this.$store.getters.getActiveWorkspaceUuid } });
      }

      if (this.$route.params.offerUuid) {
        variables.persistedFilters.push({ match: { 'offer.uuid': this.$route.params.offerUuid } });
      }

      if (this.input.status) variables.status = this.input.status;

      const response = await requests.searchOpenSearchContent(variables);

      if (!response.success) {
        this.loading = false;

        // SHOW ERROR MESSAGE
        return;
      }

      this.loading = true;
      this.candidatures = response.items;
    },
    getDefaultAvailabilityDate () {
      // Add 1 month to current date
      const nextMonth = moment().add(1, 'month');

      // Format as dd/MM/yyyy
      return nextMonth.format('DD/MM/YYYY');
    },
    handleLoading (value) {
      this.isLoading = value;
    },
    toggleChatFullScreen () {
      this.isChatFullscreen = !this.isChatFullscreen;
    },
    changeSideBar () {
      this.hideSidebar = !this.hideSidebar;
    },
    changeOpenPanels (panel, isOpen, panelIndex) {
      if (isOpen) {
        if (!this.tabs.panels[panel].includes(panelIndex)) {
          this.tabs.panels[panel].push(panelIndex);
        }
      } else {
        this.tabs.panels[panel] = this.tabs.panels[panel].filter(pan => pan !== panelIndex);
      }
    },
    handleValidation (vueTelPhoneObject) {
      this.mobilePhoneIsValid = vueTelPhoneObject.valid;
    },
    removeFields (input) {
      delete input.collaborator;
      delete input.recruiter;
      delete input.offer;
    },
    async fetchApplication () {
      this.handleLoading(true);

      const response = await requests.getApplication(this.candidatureUuid);

      if (response?.success) {
        if (!response.data) {
          this.$router.push({ name: 'error', params: { errorCode: 404 } });
          return;
        }

        const workspaceID = response.data.entity?.workspaceSettings?.workspaceID;

        if (!response.data.isSpontaneousApplication && !this.hasWorkspaceAccess(workspaceID, 'WRITE')) {
          this.$router.push({ name: 'error', params: { errorCode: 401 } });
          return;
        }

        const nextActiveWorkspace = response.data.isSpontaneousApplication ? 'spontaneous' : workspaceID;

        if (nextActiveWorkspace === 'spontaneous' && this.$store.state.activeWorkspace !== 'spontaneous') {
          this.$store.commit('setActiveWorkspace', nextActiveWorkspace);
          // this.$router.push({ name: 'candidature-spontanee', params: { uuid: response.data.uuid, mode: 'vue' } });
        }
        if (nextActiveWorkspace !== 'spontaneous' && this.$store.state.activeWorkspace === 'spontaneous') {
          this.$store.commit('setActiveWorkspace', nextActiveWorkspace);
          // this.$router.push({ name: 'offer-candidature', params: { uuid: response.data.uuid, mode: 'vue' } });
        }

        this.application = response.data;
      }

      this.handleLoading(false);
    },
    handleChanges (form, field, value) {
      if (form === 'collaborator') {
        if (field.name === 'mobilephone') {
          value = this.mobilePhoneIsValid ? value : null;
        }
      }

      if (form === 'application' && field.name === 'disabilityStatus') {
        const disabilityField = this.forms[form].fields.find(f => f.name === 'disability');
        if (disabilityField) {
          this.$set(disabilityField, 'hidden', !value);
        }
      }

      this.input[field.name] = value;
    },
    async updateApplication (input, fieldName) {
      if (!this.canPerformAction('EDIT_APPLICATION')) return;

      this.handleLoading(true);

      if (fieldName === 'stared') {
        input.stared = !input.stared;
        delete input.notes;
      }

      const inputCopyForClick = { ...input };
      this.removeFields(inputCopyForClick);
      const response = await requests.saveApplication({ input: inputCopyForClick, isEditMode: true });

      if (!response.success) {
        this.$store.commit('setSnackbar', {
          text: 'Erreur lors de l\'enregistrement.',
          color: 'error'
        });
      } else {
        this.application = response.data;

        this.$store.commit('setSnackbar', {
          text: 'Enregistrer avec succès.',
          color: 'success'
        });
      }

      this.handleLoading(false);
    },
    async updateProspect (input) {
      if (!this.canPerformAction('EDIT_PROSPECT')) return;

      this.handleLoading(true);

      const inputCopyForClick = { ...input };
      this.removeFields(inputCopyForClick);
      const response = await requests.updateProspect({ input: inputCopyForClick, isEditMode: true });

      if (!response.success) {
        this.$store.commit('setSnackbar', {
          text: 'Erreur lors de l\'enregistrement.',
          color: 'error'
        });
      } else {
        this.application.collaborator = response.data;

        this.$store.commit('setSnackbar', {
          text: 'Enregistrer avec succès.',
          color: 'success'
        });
      }

      this.handleLoading(false);
    },
    setAplicationAttachments (attachments) {
      const applicationAttachments = [];

      if (this.application.attachments) {
        applicationAttachments.push(...this.application.attachments);
      }

      applicationAttachments.push(...attachments);

      this.updateApplication({ uuid: this.application.uuid, attachments: applicationAttachments });
    },
    editAplicationAttachments (attachments) {
      this.updateApplication({ uuid: this.application.uuid, attachments: attachments });
    },
    addNotes (text) {
      if (!this.application.notes) {
        this.application.notes = [];
      }

      const newNote = {
        id: `note_${this.generateUniqueId()}`,
        collaborator: {
          uuid: this.user.uuid,
          ...this.user
        },
        text: text,
        createTime: moment().toISOString()
      };

      this.application.notes.push(newNote);

      const transformedNotes = this.application.notes.map(note => ({
        ...note,
        collaborator: note.collaborator?.uuid || note.collaborator
      }));

      this.updateApplication({
        uuid: this.application.uuid,
        notes: transformedNotes
      });
    },
    deleteAplicationAttachment (attachmentIndex) {
      const applicationAttachments = Array.isArray(this.application.attachments)
        ? [...this.application.attachments]
        : [];

      applicationAttachments.splice(attachmentIndex, 1);

      this.updateApplication({
        uuid: this.application.uuid,
        attachments: applicationAttachments
      });
    },
    competencePopup (competenceType, competenceIndex, data, isDelete) {
      let popupType;
      let handler;

      if (isDelete) {
        popupType = 'delete';
        handler = checked => this.deleteCompetence(competenceType, competenceIndex, checked);
      } else if (competenceIndex === undefined || competenceIndex === null) {
        popupType = 'add';
        handler = checked => this.addCompetence(competenceType, data, checked);
      } else {
        popupType = 'edit';
        handler = checked => this.editCompetence(competenceType, competenceIndex, data, checked);
      }

      const popup = this.forms[competenceType].popup[popupType];

      const canPerform = this.canPerformAction('EDIT_PROSPECT');
      const isAdd = popupType === 'add';
      const hasId = !!this.application[competenceType]?.[competenceIndex]?.id;
      const isAllowed = canPerform && (isAdd || hasId);

      if (!isAllowed) {
        delete popup.checkbox;
      }

      this.$store.commit('setDialog', {
        show: true,
        ...popup,
        handleAccept: handler
      });
    },
    async addCompetence (competenceType, data, checked) {
      const id = data.id || `${competenceType}_${this.generateUniqueId()}`;
      const newItem = { ...data, id };

      const appList = [...(this.application[competenceType] || [])];
      appList.unshift(newItem);

      if (competenceType === 'experiences') appList.sort(this.sortExperience);
      if (competenceType === 'languages') appList.sort(this.sortLanguages);

      const cleanedAppList = competenceType === 'formations'
        ? appList.map(({ qualification, ...rest }) => rest)
        : appList;

      this.updateApplication({
        uuid: this.application.uuid,
        [competenceType]: cleanedAppList
      });

      if (checked) {
        const prospectList = [...(this.application.collaborator[competenceType] || [])];
        prospectList.unshift(newItem);

        if (competenceType === 'experiences') prospectList.sort(this.sortExperience);
        if (competenceType === 'languages') prospectList.sort(this.sortLanguages);

        const cleanedProspectList = competenceType === 'formations'
          ? prospectList.map(({ qualification, ...rest }) => rest)
          : prospectList;

        this.updateProspect({
          uuid: this.application.collaborator.uuid,
          [competenceType]: cleanedProspectList
        });
      }
    },

    async editCompetence (competenceType, index, data, checked) {
      const appList = [...(this.application[competenceType] || [])];
      const targetItem = appList[index];

      const id = targetItem.id || data.id || `${competenceType}_${this.generateUniqueId()}`;
      const newItem = { ...targetItem, ...data, id };

      appList[index] = newItem;

      if (competenceType === 'experiences') appList.sort(this.sortExperience);
      if (competenceType === 'languages') appList.sort(this.sortLanguages);

      const cleanedAppList = competenceType === 'formations'
        ? appList.map(({ qualification, ...rest }) => rest)
        : appList;

      this.updateApplication({
        uuid: this.application.uuid,
        [competenceType]: cleanedAppList
      });

      if (checked) {
        const prospectList = [...(this.application.collaborator[competenceType] || [])];

        const prospectIndex = prospectList.findIndex(item => item.id === id);

        if (prospectIndex !== -1) {
          prospectList[prospectIndex] = { ...prospectList[prospectIndex], ...newItem };
        } else {
          prospectList.unshift(newItem);
        }

        if (competenceType === 'experiences') prospectList.sort(this.sortExperience);
        if (competenceType === 'languages') prospectList.sort(this.sortLanguages);

        const cleanedProspectList = competenceType === 'formations'
          ? prospectList.map(({ qualification, ...rest }) => rest)
          : prospectList;

        this.updateProspect({
          uuid: this.application.collaborator.uuid,
          [competenceType]: cleanedProspectList
        });
      }
    },

    async deleteCompetence (competenceType, index, checked) {
      const appList = [...(this.application[competenceType] || [])];
      const targetItem = appList[index];
      const id = targetItem ? targetItem.id : null;

      appList.splice(index, 1);

      const cleanedAppList = competenceType === 'formations'
        ? appList.map(({ qualification, ...rest }) => rest)
        : appList;

      this.updateApplication({
        uuid: this.application.uuid,
        [competenceType]: cleanedAppList
      });

      if (checked && id) {
        let prospectList = [...(this.application.collaborator[competenceType] || [])];

        prospectList = prospectList.filter(item => item.id !== id);

        const cleanedProspectList = competenceType === 'formations'
          ? prospectList.map(({ qualification, ...rest }) => rest)
          : prospectList;

        this.updateProspect({
          uuid: this.application.collaborator.uuid,
          [competenceType]: cleanedProspectList
        });
      }
    },
    generateUniqueId () {
      const timestamp = Date.now();
      const random = Math.random().toString(36).substring(2, 15);
      const uniqueId = `${timestamp}_${random}`;
      return uniqueId;
    },
    sortExperience (a, b) {
      // Convert dates to timestamps for reliable comparison
      const aStart = a.startDate ? new Date(a.startDate).getTime() : 0;
      const bStart = b.startDate ? new Date(b.startDate).getTime() : 0;
      const aEnd = a.endDate ? new Date(a.endDate).getTime() : 0;
      const bEnd = b.endDate ? new Date(b.endDate).getTime() : 0;

      // Handle cases where dates are missing
      if (!aStart && bStart) return 1;
      if (aStart && !bStart) return -1;

      // Sort by start date descending (most recent first)
      if (aStart !== bStart) {
        return bStart - aStart;
      }

      // If start dates are equal, sort by end date descending
      return bEnd - aEnd;
    },
    sortLanguages (a, b) {
      const aWeight = this.references.levelsWeight[a.level] || Number.MAX_SAFE_INTEGER;
      const bWeight = this.references.levelsWeight[b.level] || Number.MAX_SAFE_INTEGER;

      return aWeight - bWeight;
    },
    fetchCollaboratorApplications (filterByWorkspace = false) {
      this.handleLoading(true);
      const filterAux = [];

      if (this.activeWorkspace !== 'spontaneous') {
        filterAux.push((filterByWorkspace === true
          ? { bool: { must: [{ term: { 'entity.uuid': this.getActiveWorkspaceUuid } }] } }
          : { bool: { must_not: [{ term: { 'entity.uuid': this.getActiveWorkspaceUuid } }] } }
        ));
      }

      requests.getCollaboratorApplications({
        start: 0,
        limit: 1000,
        query: {
          bool: {
            filter: [
              { term: { wtype: 'application' } },
              { term: { 'collaborator.uuid': this.application.collaborator.uuid } },
              {
                bool: {
                  must_not: [
                    { term: { canceled: true } },
                    { term: { uuid: this.application.uuid } },
                    (this.activeWorkspace === 'spontaneous' && filterByWorkspace
                      ? { term: { isSpontaneousApplication: false } }
                      : { term: { isSpontaneousApplication: true } }
                    )
                  ]
                }
              },
              ...filterAux
            ]
          }
        },
        sort: [{ lastUpdateTime: { order: 'desc' } }]
      }).then(response => {
        if (response.success) {
          const applicationsKey = filterByWorkspace ? 'center' : 'other';
          this.applications[applicationsKey] = response.data;
        }
      }).finally(() => this.handleLoading(false));
    },
    changedTab (tab) {
      this.scrollTo('scrollTarget');

      if (tab === 'center-applications' && !this.applications.center.length) {
        this.fetchCollaboratorApplications(true);
      }
      if (tab === 'other-applications' && !this.applications.other.length) {
        this.fetchCollaboratorApplications();
      }
    },
    viewPreviewsCandidature () {
      if (this.canViewPreviewsCandidature) return;

      // Find the current index in the original array
      const currentIndex = this.candidatures.findIndex(app => app.uuid === this.application.uuid);

      // Move to the next item (which is actually previous in display order)
      const prevIndex = currentIndex + 1;

      if (prevIndex < this.candidatures.length) {
        const prevAppUuid = this.candidatures[prevIndex].uuid;

        // Determine the correct route based on current route
        const currentRouteName = this.$router.currentRoute.name;
        let routeName = this.activeWorkspace === 'spontaneous' ? 'candidature-spontanee' : 'candidature';
        const params = { candidatureUuid: prevAppUuid };

        if (currentRouteName === 'offer-candidature') {
          routeName = 'offer-candidature';
          params.offerUuid = this.$route.params.offerUuid;
        }

        this.$router.push({
          name: routeName,
          params: params
        }).catch(err => {
          if (err.name !== 'NavigationDuplicated') throw err;
        });
      }
    },

    viewNextCandidature () {
      if (this.canViewNextCandidature) return;

      // Find the current index in the original array
      const currentIndex = this.candidatures.findIndex(app => app.uuid === this.application.uuid);

      // Move to the previous item (which is actually next in display order)
      const nextIndex = currentIndex - 1;

      if (nextIndex >= 0) {
        const nextAppUuid = this.candidatures[nextIndex].uuid;

        // Determine the correct route based on current route
        const currentRouteName = this.$router.currentRoute.name;
        let routeName = this.activeWorkspace === 'spontaneous' ? 'candidature-spontanee' : 'candidature';
        const params = { candidatureUuid: nextAppUuid };

        if (currentRouteName === 'offer-candidature') {
          routeName = 'offer-candidature';
          params.offerUuid = this.$route.params.offerUuid;
        }

        this.$router.push({
          name: routeName,
          params: params
        }).catch(err => {
          if (err.name !== 'NavigationDuplicated') throw err;
        });
      }
    }
  }
};
</script>

<style>
.v-list-item__subtitle,
.v-list-item__title {
  white-space: break-spaces !important;
}

.switch-flex-column.v-input--switch .v-input__slot {
  display: flex;
  flex-direction: column;
  align-items: start;
}

.vue-tel-input.vue-tel-input {
  border-top: 0;
  border-right: 0;
  border-left: 0;

  &:focus-within {
    box-shadow: none;
    border-color: #c71900;
  }
}
</style>
